import { render } from "./HeaderDesktop.vue?vue&type=template&id=28fdcbc7&scoped=true"
import script from "./HeaderDesktop.vue?vue&type=script&lang=js"
export * from "./HeaderDesktop.vue?vue&type=script&lang=js"

import "./HeaderDesktop.vue?vue&type=style&index=0&id=28fdcbc7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28fdcbc7"]])

export default __exports__